export const GET_FILTER_DATA_REQUEST = "GET_FILTER_DATA_REQUEST";
export const GET_FILTER_DATA_SUCCESS = "GET_FILTER_DATA_SUCCESS";
export const GET_FILTER_DATA_FAILURE = "GET_FILTER_DATA_FAILURE";
export const SET_SIDEBAR_FILTERS = "SET_SIDEBAR_FILTERS";
export const RESET_SIDEBAR_FILTERS = "RESET_SIDEBAR_FILTERS";

export interface FilterState {
  filterData: any;
  loading: boolean;
  error: any;
  selectedFilters: {
    fuel_type?: string;
    price?: any;
    [key: string]: any;
  };
}

interface GetFilterDataRequest {
  type: typeof GET_FILTER_DATA_REQUEST;
  payload: any;
}

interface GetFilterDataSucess {
  type: typeof GET_FILTER_DATA_SUCCESS;
  payload: any;
}

interface GetFilterDataFailure {
  type: typeof GET_FILTER_DATA_FAILURE;
  payload: string;
}

interface GetSidebarFailure {
  type: typeof SET_SIDEBAR_FILTERS;
  payload: string;
}

interface ResetSidebarFilter {
  type: typeof RESET_SIDEBAR_FILTERS;
}

export type FilterActionTypes =
  | GetFilterDataRequest
  | GetFilterDataSucess
  | GetFilterDataFailure
  | GetSidebarFailure
  | ResetSidebarFilter
  | ResetSidebarFilter;
